import * as React from 'react'

import { Container } from 'components/Layout'
import Page from 'components/Page'
import PageHeader from 'components/Page/PageHeader'
import { Crumbs, Crumb } from 'components/BreadCrumbs'
import { BillingBillsList } from 'features/BillingBills/BillingBillsList'

export interface IBillingBillsProps {
  location: {
    query: {
      page?: string
      ban?: string
    }
  }
  billingAccounts: any
  showBillingCreateFormModal: any
}

export class BillingBillsComponent extends React.Component<IBillingBillsProps> {
  render() {
    const { location, billingAccounts, showBillingCreateFormModal } = this.props
    return (
      <Page layout={{ header: 'app' }} title="Billing">
        <PageHeader>
          <Crumbs title="Billing">
            <Crumb active to="/dashboard/billing">
              Bills
            </Crumb>
            <Crumb to="/dashboard/billing/payments">Payments</Crumb>
            {billingAccounts.length === 0 && (
              <Crumb onClick={() => showBillingCreateFormModal()}>Add Billing Account</Crumb>
            )}
            {billingAccounts.length > 1 && <Crumb to="/dashboard/billing/accounts">Accounts</Crumb>}
            {billingAccounts.length === 1 && (
              <Crumb to={`/dashboard/billing/accounts/${billingAccounts[0].ban}`}>
                Billing Account
              </Crumb>
            )}
          </Crumbs>
        </PageHeader>
        <Container paddingTop paddingBottom>
          <BillingBillsList
            page={parseInt(location.query.page || '1', 10)}
            ban={location.query.ban}
          />
        </Container>
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/BillingBills/BillingBills.tsx